var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1215"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1215"
    },
    "bundlingPackage": "MeetingsPublic",
    "bundlingPackageVersion": "static-1.60743",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};